import client from 'data/client';
import { Menu } from 'data/types/menu';
import { normalizeMenu } from 'model/menu';

const getMenu = async (brand_id: string) => {
  const response = await client.get<Menu>(`/menus?brandId=${brand_id}`);

  return normalizeMenu(response.data);
};

export default getMenu;
